module.exports = __webpack_public_path__ + "static/img/B100-TOR_A.c464da0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/B100-TOR_A.jpg
// module id = bxNy
// module chunks = 0